<template lang="pug">
  v-hover(v-slot="{ hover }")
    v-card.transparent.style(tile flat @click="onSelectedItemClick(statusConfig)" ripple)
      v-row.ma-0.pa-1.style( v-if="menuGroupItem && !isKioskMode" :class="statusConfig.statusClass" no-gutters)
        v-col.caption.style(cols="6" disabled v-if="!isKioskMode") {{ statusConfig.label }}
        v-col.text-right(cols="6")
          v-icon.mr-2.ml-2.style1(small :color="statusConfig.color") {{hover ? 'fas fa-chevron-double-right' : statusConfig.icon }}
      v-row.ma-0.pa-1.fill-height( v-if="menuGroupItem && isKioskMode && reservationItem"  no-gutters )
        v-col.text-right(cols="1")
          v-icon.mr-2.ml-6.style1(medium :color="statusConfig.color") {{statusConfig.icon }}
      v-row.ma-0.pa-1( v-else :class="getEventClass()" no-gutters)
        v-col.caption {{ eventName }}

</template>

<script lang="ts">
import Vue from 'vue'
import MenuGroupItem from '@/model/MenuGroupItem'
import DailyMenuOffer from '@/model/DailyMenuOffer'
import MenuReservationItem from '@/model/MenuReservationItem'
import {Component, Prop} from "vue-property-decorator";
import {SET_SELECTED_MENU_ITEM} from "@/store/action-types";
import router from "@/router";
import {RawLocation} from "vue-router/types/router";
import {GET_MODE} from "@/store/getter-types";


interface ItemStatusConfig {
  [key: string]: {
    statusClass: string
    icon: string
    color: string
    label: string
  }
}
@Component({
  components: {}
})
export default class CalendarGroupKindItem extends Vue {

  @Prop({type: Object as () => MenuGroupItem}) menuGroupItem!: MenuGroupItem
  @Prop({type: Object as () => DailyMenuOffer}) offerItem!: DailyMenuOffer
  @Prop({type: Object as () => MenuReservationItem}) reservationItem!: MenuReservationItem
  @Prop({type: String}) eventName!: string

  private statusClass: string = ''
  private icon: string = ''
  private color: string = ''
  private label: string = ''
  private selectedMenu: string | null = null

  get isKioskMode (): boolean {
    return this.$store.getters[GET_MODE] === 'kiosk'
  }

  get showGroupLabel(): boolean {
    const subGroupCount = this.menuGroupItem.subGroupList.length

    if (subGroupCount !== 1) {
      return true
    }

    return false
  }

  get statusConfig(): any {
    let config: ItemStatusConfig = {
      active: {
        statusClass: 'active',
        icon: 'fas fa-check',
        color: 'green',
        label: this.menuGroupItem.title
      },
      canceled: {
        statusClass: 'canceled',
        icon: 'fas fa-minus-square',
        color: 'red',
        label: `${this.menuGroupItem.title} - ${this.$t('orderPage.labelStornoOrder')}`
      },
      delivered: {
        statusClass: 'delivered',
        icon: 'fas fa-cookie-bite',
        color: '#8fa2c3',
        label: `${this.menuGroupItem.title} - ${this.$t('orderPage.menuOfferDelivered')}`
      },
      default: {
        statusClass: 'no-reservation',
        icon: this.reservationItem ? '' : 'fas fa-exclamation',
        color: 'gray',
        label: this.menuGroupItem.title
      }
    }

    if (this.reservationItem && config[this.reservationItem.status]) {
      if(this.reservationItem.topMenuGroup.title === this.menuGroupItem.title) {
        return config[this.reservationItem.status]
      } else {
        return config.default
      }
      return config[this.reservationItem.status]
    }

    return config.default
  }


  getEventClass(): string {
    if (this.eventName == 'Prázdniny') {
      return 'yellow'
    } else if (this.eventName == 'Voľný deň') {
      return 'orange'
    }

    return ''
  }

  onSelectedItemClick (item: any) {
    router.push({
      name: 'Order',
      params: {
        isoWeek: this.$route.params.isoWeek,
        date: this.offerItem.formatedDbDate
      }
    } as RawLocation).catch((err: Error) => {
    })
    this.selectedMenu = item.label
    this.$store.dispatch(SET_SELECTED_MENU_ITEM, this.selectedMenu)
  }

  mounted () {
  }

}
</script>

<style lang="stylus" scoped>
.style
  cursor: pointer
.style1
  cursor: auto

.active
  background-color #c8e6c9

.canceled
  background-color #fadacd

.delivered
  background-color #c0dbff

.no-reservation
  background-color rgba(0, 0, 0, .08)

.orange
  background-color orange

.yellow
  background-color yellow

</style>
